import { Theme } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import makeStyles from "@material-ui/styles/makeStyles";
import React from "react";

type LoadingSpinnerProps = {
  children?: JSX.Element;
};

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.tooltip,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4) + "px",
  },
}));

export function LoadingSpinner({ children }: LoadingSpinnerProps) {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
      {children}
    </Backdrop>
  );
}
